<template>
  <span class="scaling-svg-container">
    <svg
      id="Icon_user"
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      class="scaling-svg"
    >
      <g id="Icon_user-2" data-name="Icon_user" transform="translate(1 1.333)">
        <path
          id="Shape"
          d="M2,4A2,2,0,1,1,4,2,2,2,0,0,1,2,4ZM2,1A1,1,0,1,0,3,2,1,1,0,0,0,2,1Z"
          transform="translate(3 -0.333)"
          stroke="currentColor"
          stroke-width="0.5"
        />
        <path
          id="Path"
          d="M1,4C1,2.816,2.234,1,5,1S9,2.816,9,4a.5.5,0,0,0,1,0c0-1.816-1.766-4-5-4S0,2.184,0,4A.5.5,0,0,0,1,4Z"
          transform="translate(0 4.667)"
          stroke="currentColor"
          stroke-width="0.5"
        />
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class UserIcon extends Vue {}
</script>

<style>
</style>
